import { REs } from "@/utils/REs";
import Vue from "vue";

type TFormFieldRuleFunc = (value: string) => boolean;

export const createFormFieldRule = (func: TFormFieldRuleFunc, message: string) => (v: string) => {
  if (func(v)) return true;
  return message;
};

type TFormFieldRule = ReturnType<typeof createFormFieldRule>;

const ruleName = createFormFieldRule(
  (v) => REs.name.test(v),
  "Please check that you've selected acceptable symbols"
);

const ruleEmail = createFormFieldRule(
  (v) => REs.email.test(v),
  "Please enter a valid email address"
);

const rulePassword = createFormFieldRule(
  (v) => REs.password.test(v),
  "Please check that you've selected acceptable symbols"
);

const formFieldRules = {
  name: ruleName,
  email: ruleEmail,
  password: rulePassword,
};

type TFormFieldRuleAlias = keyof typeof formFieldRules;

export class CFormField {
  value = "";
  props = {
    label: "",
    rules: [] as TFormFieldRule[],
    disabled: false,
  };
  totallyDisabled = false;

  constructor(label: string) {
    this.props.label = label;
  }

  addRuleByAlias(alias: TFormFieldRuleAlias) {
    const rule = formFieldRules[alias];
    this.props.rules.push(rule);

    return this;
  }

  addRule(rule: TFormFieldRule) {
    this.props.rules.push(rule);

    return this;
  }

  setTotallyDisabled() {
    this.setDisabled();

    this.totallyDisabled = true;
  }

  setDisabled() {
    this.props.disabled = true;
  }

  setAbleBodied() {
    if (!this.totallyDisabled) this.props.disabled = false;
  }
}

export const validateFormFields = (fields: CFormField[]) => {
  return fields.every((field) => {
    if (field.value.length === 0) return false;

    const {
      value,
      props: { rules },
    } = field;

    const isEachFieldValid = rules.every((rule) => rule(value) === true);

    if (!isEachFieldValid) return false;

    return true;
  });
};

export const setFormFieldsDisabled = (fields: CFormField[]) => {
  fields.forEach((field) => field.setDisabled());
};

export const setFormFieldsAbleBodied = (fields: CFormField[]) => {
  fields.forEach((field) => field.setAbleBodied());
};

export const setFormFieldsDisabledWithTimer = (fields: CFormField[], secCount = 3) => {
  setFormFieldsDisabled(fields);
  setTimeout(() => setFormFieldsAbleBodied(fields), secCount * 1000);
};

export type TInput = Vue & {
  showError: (b?: boolean) => void;
};
